/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Trip_Picker_No_VehiclesInputs */

const vi_trip_picker_no_vehicles = /** @type {(inputs: Trip_Picker_No_VehiclesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có xe sẵn sàng`)
};

/**

* @param {Trip_Picker_No_VehiclesInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const trip_picker_no_vehicles = /** @type {((inputs?: Trip_Picker_No_VehiclesInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Trip_Picker_No_VehiclesInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_trip_picker_no_vehicles(inputs)
});